<h1 mat-dialog-title>{{ 'organizationAdmin.users.transferLeadAdmin.title' | transloco }}</h1>

<mat-dialog-content>
  <p class="dialog-subtitle">{{ 'organizationAdmin.users.transferLeadAdmin.subtitle' | transloco: { name: currentLeadAdminName } }}</p>
  <p class="dialog-subtitle">{{ 'organizationAdmin.users.transferLeadAdmin.losesRoleHint' | transloco }}</p>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [formControl]="searchControl" [placeholder]="'organizationAdmin.users.transferLeadAdmin.searchPlaceholder' | transloco" />
  </mat-form-field>

  <div class="user-list">
    @for (user of filteredCandidates(); track user.id) {
      <button type="button" class="user-row" [class.selected]="selectedUser() === user" (click)="selectUser(user)">
        <mat-icon>{{ selectedUser() === user ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
        <span class="user-row-text">
          <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
          <span class="user-email">{{ user.email }}</span>
        </span>
      </button>
    }

    @if (filteredCandidates().length === 0) {
      <p class="empty-text">{{ 'organizationAdmin.users.transferLeadAdmin.noResults' | transloco }}</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <span class="dialog-actions-spacer"></span>
  <button mat-button color="primary" class="link-button" type="button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
    {{ 'common.buttons.cancel' | transloco }}
  </button>
  <button mat-flat-button color="primary" type="button" [disabled]="!selectedUser()" (click)="confirm()">
    <mat-icon>check</mat-icon>
    {{ 'organizationAdmin.users.transferLeadAdmin.confirmButton' | transloco }}
  </button>
</mat-dialog-actions>
